/* Her Collection — subtle scroll reveal animations */

(function () {
  'use strict';

  var root = document.documentElement;
  var observer = null;
  var SAFETY_MS = 3000;
  var VEIL_OFFSET_MS = 300;

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -40px 0px'
    });
  }

  function collect(root) {
    var elements = Array.from(root.querySelectorAll('.hc-reveal'));
    if (root !== document && root.classList.contains('hc-reveal')) elements.unshift(root);
    return elements;
  }

  function reveal(root) {
    collect(root).forEach(function (el) {
      if (el.classList.contains('is-visible')) return;
      if (observer) {
        observer.observe(el);
      } else {
        el.classList.add('is-visible');
      }
    });
  }

  function init() {
    /* If the CSS safety fallback has already shown the cards, keep the on-screen ones shown. */
    if (performance.now() > SAFETY_MS) {
      var viewportHeight = window.innerHeight;
      collect(document).forEach(function (el) {
        if (!el.classList.contains('hc-reveal--card')) return;
        var rect = el.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < viewportHeight) el.classList.add('is-visible');
      });
    }
    root.classList.add('hc-anim-ready');
    reveal(document);
  }

  /* Behind the collection page veil, let the veil thin out before the cards start moving. */
  var veil = document.querySelector('.hc-page-veil');
  if (veil && observer) {
    var started = false;
    var start = function () {
      if (started) return;
      started = true;
      window.setTimeout(init, VEIL_OFFSET_MS);
    };
    var veilFading = veil.getAnimations && veil.getAnimations().some(function (a) {
      if (a.playState === 'finished') return true;
      var timing = a.effect && a.effect.getComputedTiming ? a.effect.getComputedTiming() : null;
      return a.playState === 'running' && !!timing && timing.progress !== null && timing.progress > 0;
    });
    if (veilFading) {
      start();
    } else {
      veil.addEventListener('animationstart', start, { once: true });
      window.setTimeout(start, SAFETY_MS);
    }
  } else {
    init();
  }

  /* Theme Editor re-renders sections after a settings change; observe the new nodes. */
  document.addEventListener('shopify:section:load', function (event) {
    reveal(event.target);
  });
})();
